import { useNavigate } from "react-router-dom";
import Logo from "../assets/img/logo.png";
import { useState } from "react";
import userService from "../services/userService";
import localStorageService from "../services/localStorageService";
import LoadingIndicator from "../components/common/LoadingIndicator";
import { Helmet } from "react-helmet-async";
import appSettings from "../appSettings";
import Footer from "../components/work/layout/Footer";

const Login: React.FC<{ onLoginOk: any }> = ({ onLoginOk }) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const navigate = useNavigate();

  const [isBusy, setIsBusy] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState<string>("");

  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const onEmailChange = (event: any) => {
    const newValue = event.target.value;
    setEmail(newValue);
  };

  const onPasswordChange = (event: any) => {
    const newValue = event.target.value;
    setPassword(newValue);
  };

  const onLogoClick = () => {
    navigate("/");
  };

  const clearError = () => {
    setErrorMessage("");
  };

  const onSubmit = async (event: any) => {
    event.preventDefault();

    clearError();

    try {
      setIsBusy(true);
      const data: any = await userService.login(email, password);
      setIsBusy(false);

      if (!data.success) {
        const errorMessage = data.error;
        setErrorMessage(errorMessage);

        return;
      }

      localStorageService.setLoginData(data.accessToken);

      onLoginOk(data.user);

      navigate("/work");
    } catch (error: any) {
      const errorMessage = error.response.data;
      setErrorMessage(errorMessage);
    }
  };

  return (
    <>
      <Helmet
        onChangeClientState={() => setTimeout(() => setIsLoading(false), 500)}
      >
        <link
          rel="stylesheet"
          type="text/css"
          href={`/assets/css/app-work.css?ver=${appSettings.appVersion}`}
        />
      </Helmet>
      {isLoading && <div></div>}
      {!isLoading && (
        <>
          <div className="auth-layout auth-layout-split">
            {/* <!-- Split Layout: Form Side --> */}
            <div className="auth-form-side">
              <div className="auth-container">
                {/* <!-- Logo --> */}
                <div
                  className="auth-logo"
                  style={{ cursor: "pointer" }}
                  onClick={onLogoClick}
                >
                  <img src={Logo} alt="Work Order Direct" />
                  <span>Work Order Direct</span>
                </div>

                <div className="auth-card">
                  <div className="auth-card-header">
                    <h1 className="auth-title">Login to Your Account</h1>
                    <p className="auth-subtitle">
                      Enter your email and password to login
                    </p>
                  </div>

                  <form className="auth-form" noValidate onSubmit={onSubmit}>
                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="name@company.com"
                        required
                        value={email}
                        onChange={onEmailChange}
                      />
                      <div className="invalid-feedback">
                        Please enter a valid email address.
                      </div>
                    </div>

                    <div className="form-group">
                      <div className="d-flex justify-content-between align-items-center">
                        <label htmlFor="password" className="form-label">
                          Password
                        </label>
                        {/* <a
                          href="auth-forgot-password.html"
                          className="auth-link small"
                        >
                          Forgot password?
                        </a> */}
                      </div>
                      <div className="input-group">
                        <input
                          type="password"
                          className="form-control"
                          id="password"
                          name="password"
                          placeholder="Enter your password"
                          required
                          value={password}
                          onChange={onPasswordChange}
                        />
                        {/* <button
                          className="btn btn-outline-secondary"
                          type="button"
                          data-toggle-password
                        >
                          <i className="bi bi-eye"></i>
                        </button> */}
                      </div>
                      <div className="invalid-feedback">
                        Please enter your password.
                      </div>
                    </div>

                    {/* <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="remember"
                        name="remember"
                      />
                      <label className="form-check-label" htmlFor="remember">
                        Keep me signed in
                      </label>
                    </div> */}

                    <button
                      type="submit"
                      className="btn btn-primary btn-block"
                      disabled={isBusy}
                    >
                      Login
                    </button>

                    {/* <div className="auth-divider">
                      <span>or continue with</span>
                    </div>

                    <div className="auth-social">
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                      >
                        <i className="bi bi-google"></i>
                        Google
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                      >
                        <i className="bi bi-microsoft"></i>
                        Microsoft
                      </button>
                    </div> */}

                    {isBusy && (
                      <div className="text-center mt-3">
                        <LoadingIndicator />
                      </div>
                    )}
                    {errorMessage !== "" && (
                      <div className="col-md-12 text-center mt-3 mb-3">
                        <div className="error-message">{errorMessage}</div>
                      </div>
                    )}
                  </form>

                  {/* <p className="auth-footer-text">
                    Don't have an account?{" "}
                    <a href="auth-register.html" className="auth-link">
                      Create account
                    </a>
                  </p> */}
                </div>

                {/* <!-- Footer --> */}
                <Footer />
              </div>
            </div>

            {/* <!-- Split Layout: Brand Side --> */}
            {/* <div className="auth-brand-side">
              <div className="auth-brand-content">
                <div className="auth-brand-icon">
                  <i className="bi bi-shield-lock"></i>
                </div>
                <h2 className="auth-brand-title">Welcome Back</h2>
                <p className="auth-brand-text">
                  Sign in to access your dashboard, manage your projects, and
                  collaborate with your team.
                </p>
                <div className="auth-brand-features">
                  <div className="auth-brand-feature">
                    <i className="bi bi-check-circle-fill"></i>
                    <span>256-bit SSL Encryption</span>
                  </div>
                  <div className="auth-brand-feature">
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Two-Factor Authentication</span>
                  </div>
                  <div className="auth-brand-feature">
                    <i className="bi bi-check-circle-fill"></i>
                    <span>24/7 Security Monitoring</span>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </>
      )}
    </>
  );
};

export default Login;
